import { MiddlewareAPI } from '@reduxjs/toolkit';
import { trevorAxios } from '@/api';
import { ACTION_CHANGE_DIMENSION } from '@/components/HighlightFeature';
import { UserActionPayload } from './types';
import {
  createActionsData,
  getCurrentState,
  getNextSummarizeStep,
  processAction,
} from './utils';

export const trackChangeDimensionAction = (
  store: MiddlewareAPI,
  action: UserActionPayload,
  datasourceId?: string,
) => {
  const nextSummarizeStep = getNextSummarizeStep(action);
  if (!nextSummarizeStep) return;

  const currentState = getCurrentState(
    store,
    nextSummarizeStep,
    (current, next) =>
      current.keys().length !== 0 &&
      JSON.stringify(current.keys()) !== JSON.stringify(next.keys()),
  );
  if (!currentState) return;

  trevorAxios
    .post(
      `datasources/${datasourceId}/actions`,
      createActionsData(ACTION_CHANGE_DIMENSION),
    )
    .then(processAction(ACTION_CHANGE_DIMENSION, store));
};
